import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getTeamTargets(data) {
    return request.get(`/${platform}/team_targets`,data)
}

export function storeOrUpdateTeamTarget(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/team_targets/${data.id}` : `/${platform}/team_targets`;
    return request[method](url, data)
}

export function deleteTeamTarget(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/team_targets/${ids}`)
}